import React from "react";
import api from '../../utils/api';
import utils from "utils";
import ListComponent from "Components/ListComponent";
import "./Others.scss";
import { Collapse, Table, Card, Tabs, Empty, Descriptions, Row, Col } from "antd";
import { CONSTANTS } from "utils/constant";
import Loader from "Components/Loader";
const { Panel } = Collapse;
const columns = [
  {
    title: 'Asana Name',
    dataIndex: 'asana_name',
    key: 'asana_name',
    width:"220px"
  },
  {
    title: 'No. of cycles',
    dataIndex: 'number_of_cycles',
    key: 'number_of_cycles',
    width:"120px"
  },
  {
    title: 'Precautions',
    dataIndex: 'precautions',
    key: 'precautions',
    width:"220px"
  },
  {
    title: 'Recommendations',
    dataIndex: 'recommendations',
    key: 'recommendations',
    width:"220px"
  },
];
export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      prescriptionData: [],
      doctor_name: "",
      appointment_date: "",
      allPrescriptionsList:[],
      isLoading: false,
    };
  }
  componentDidMount() {
    // if(this.props?.from !="consultation")
    //   this.getPrescription(this.props.data?.appointment_id);
      this.getAllPrescriptions();
    // if(this.props?.from !="consultation")
    //   this.generatePdfAllopathy();
    
  }
  getAllPrescriptions() {
    let data = {
      patient_id: this.props?.data?.patient_id
    }
    this.setState({ isLoading: true });
    if(this.props?.recorddata){
      this.setState({
        allPrescriptionsList: this.props?.recorddata,
        prescriptionCount: this.props?.recorddata.length,
        isLoading: false
      })
    }
    else{
    api.get_all_prescriptions(data)
      .then((res) => {
        this.setState({
          allPrescriptionsList: res.data?.data?.results,
          prescriptionCount: res.data?.data?.count,
          isLoading: false
        })
      })
      .catch(() => {
      })}
  }
  // formatInstructtion(value){
  //   tempvalue=value.split(".")
  //   tempvalue.charAt(0).toUpperCase() + tempvalue.slice(1)
  //   tempvalue.
  // }
  getPrescription(id) {
    this.setState({ isLoading: true,
      prescriptionData: undefined
    });
    api
      .prescription_list(id)
      .then((response) => {
        if(response?.data?.status == 200){
        let { doctor_name, appointment_date, ayurveda_medicine, allopathy_medicine } = response.data?.data || {};
        this.setState({
          doctor_name: doctor_name || "",
          appointment_date: appointment_date || "",
          prescriptionData: allopathy_medicine || [],
          isLoading: false
        });
        }
      })
      .catch(() => {
        this.setState({
          prescriptionData: null,
          isLoading: false
        });
      });
    api.get_prescription_pdf(id)
      .then((response) => {
        let { doctor_detail, patient_detail, consultation_date, medicine } = response?.data?.data;
        this.setState({
          doctor_detail: doctor_detail || {},
          patient_detail: patient_detail || {},
          medicine: medicine || {},
          consultation_date: consultation_date || {},
        })
      })
      .catch(() => {
      })
  }
  generatePdfAllopathy() {
    let data = {
      "appointment_id": this.props.data?.appointment_id,
      "type": "allopathy"
    }
    this.setState({ isLoading: true });
    api.get_prescription_pdf_allopathy(data)
      .then((response) => {
        let { doctor_detail, patient_detail, consultation_date, medicine } = response?.data?.data;
        this.setState({
          doctor_detail: doctor_detail || {},
          patient_detail: patient_detail || {},
          medicine: medicine || {},
          consultation_date: consultation_date || {},
          isLoading: false 
        })
      })
      .catch(() => {
      })
  }
  onChange() {
  }
  printAllopathy() {
    <div>Hello</div>
  }
  render() {
    return (
    <>
    {this.state.isLoading ? (
        <Loader />
      ) : (
      <div>
        <div className="precription-popup react-screen">
          <div className="main-div">
            {this.props.from !== "consultation" ?  <div className="prescription-header">
              <div>Prescription Summary</div>
              {/* <div>Prescribed by {this.state.doctor_name ? (utils.FormatName(this.state.doctor_name, true)) : '-'}</div> */}
            </div> : null }
            {this.state.prescriptionCount != 0 ?
              <div className="prescription-content">
                {(this.state?.allPrescriptionsList || []).map((p, i) => {
                  return (
                    <div key={i} >
                      <Collapse onChange={this.onChange}
                       bordered={false}  ghost={true} 
                      // className='prescription-list-container' expandIconPosition="start"                 
                       collapsible="icon" defaultActiveKey={[1]}
                      >
                        <Panel className={this.props?.recorddata?"headerHiddenPanel":""} header={(!this.props?.recorddata)&&(<div>{utils.FormatDate(p.app_date_time, "DATE_14")}, {utils.FormatDate(p.app_date_time, "TIME_1")}</div>)} key="1"
                           extra={(!this.props?.recorddata)&&(<div>{utils.FirstNameLastName(utils.salutationPrefixName(p?.doctor_salutation,utils.getDisplayName(p?.consultation_doctor, p?.doctor_last_name)), "250px")}</div>)}
                           showArrow={false}
                        ><div className="innerPanelShow">
                      {p.is_prescription_required  ?
                      <>
                        <div style={{paddingBottom:"12px"}}
                        //  style={{padding:"0px 15px"}}
                        >
                        {p?.comments?.trim().length>0 && <Descriptions
                                            column={1} className="prescriptionDiagnosis"
                                   size="middle"
                                   bordered
                                  //  style={{marginBottom:"20px"}}
                                   labelStyle={{ width: "20%"}}
                                  >
                        <Descriptions.Item label={CONSTANTS.CLINICIAN_COMMENTS}>{p?.comments}</Descriptions.Item></Descriptions>}
                                {/* {p.comorbidities?.length > 0 ?
                                   <Descriptions
                                   size="middle"
                                   bordered
                                   style={{marginBottom:"20px"}}
                                   labelStyle={{ width: "20%"}}
                                 >
                                   <Descriptions.Item label={CONSTANTS.COMORBITIES}>{p?.comorbidities.map((item,index)=> <li key={index}>{item}</li>)}</Descriptions.Item>
                                 </Descriptions>: null} */}
                                 {p?.clinical_diagnosis &&
                                   <Descriptions
                                   size="middle"
                                   bordered
                                   labelStyle={{ width: "20%"}} className="prescriptionDiagnosis"
                                 >
                                   <Descriptions.Item label={CONSTANTS.CUSTOM_DIAGNOSIS}>{p?.clinical_diagnosis.split("\n").map((item,index)=> <li key={index}>{item}</li>)}</Descriptions.Item>
                                 </Descriptions>}
                                </div>
                          {p.ayurveda?.is_completed ?                          
                            <Collapse
                             bordered={false} ghost={true} 
                            // expandIconPosition="start" 
                            collapsible="icon" defaultActiveKey={[1]}
                            >
                              <Panel 
                              // header="Ayurvedic" 
                              extra={<div className="prescriptionTypeTitle">Ayurvedic</div>}
                              key='1' showArrow={false}
                              >
                                {p.ayurveda.is_completed ?
                                  <div>
                                    <Row className="prescription-table-header" gutter={[8, 8]}>
                                      <Col span={5}>{CONSTANTS.BRAND_DRUG}</Col>
                                      <Col span={3}>{CONSTANTS.DOSAGE}</Col>
                                      <Col span={4}>{CONSTANTS.MED_ROUTE}</Col>
                                      <Col span={4}>{CONSTANTS.FORM}</Col>
                                      <Col span={5}>{CONSTANTS.FREQUENCY}</Col>
                                      <Col span={3}>{CONSTANTS.MED_DURATION}</Col>
                                    </Row>
                                    <ListComponent
                                      className="precription-popup-list"
                                      renderType="server"
                                      data={p.ayurveda.medicines}
                                      pagination={null}
                                      render={(listItem) => {
                                        return (
                                          <div className="prescription-card">
                                            {/* <div className="card-datas">
                                              <div className="image-traingle">
                                                <img src={icons.triangle} />
                                              </div>

                                              <div className="medicine-datas">
                                                <div className="tablet-name">{listItem?.drug_name}</div>
                                                <div className="tablet-name">{listItem?.brand_name}, <span>&nbsp;{listItem?.dosage}</span></div>
                                                <div className="time-duration-tablet">
                                                  {utils.LineSplit(listItem?.instruction ? listItem?.instruction.replace(/(?<=(?:^|[.?!])\W*)[a-z]/g, i => i.toUpperCase()) : "")}
                                                </div>
                                              </div>
                                              <div className="prescription-duration">{listItem?.duration} ({listItem?.frequency})</div>
                                            </div> */}
                                            <div className="listitem-prescription">
                                              <Row gutter={[8, 8]}>
                                                <Col className="brand-name" span={5}>{utils.Typography(listItem.brand_name) || "-"}</Col>
                                                <Col span={3}>{listItem.dosage || "-"}</Col>
                                                <Col span={4}>{utils.Typography(listItem.route) || "-"}</Col>
                                                <Col span={4}>{utils.Typography(listItem.form) || "-"}</Col>
                                                <Col span={5}>{listItem.frequency || "-"}</Col>
                                                <Col span={3}>{listItem.duration || "-"}</Col>
                                              </Row>

                                              <Row>
                                                <Col span={5}>{utils.Typography(listItem.drug_name)}</Col>
                                              </Row>
                                              {listItem.adjuvant &&
                                                <Row className="adjuvant">
                                                  <Col className="adjuvant-label" span={5}>Adjuvant</Col>
                                                  <Col span={19}>{utils.Typography(listItem.adjuvant)}</Col>
                                                </Row>
                                              }
                                              {listItem.instruction &&
                                                <Row className="adjuvant-ayurvedic">
                                                  <Col className="adjuvant-label-ayurvedic" span={5}>Instructions</Col>
                                                  <Col className="instruction-label-ayurvedic" span={19}>{utils.Typography(listItem.instruction)}</Col>
                                                </Row>
                                              }
                                            </div>
                                          </div>
                                        );
                                      }}
                                    /> </div> : null}
                              </Panel>
                            </Collapse> : null}
                          {p.allopathy?.is_completed ?
                            <Collapse 
                            bordered={false} ghost={true}
                            // expandIconPosition="start"
                            collapsible="icon" defaultActiveKey={[1]}
                            >
                              <Panel 
                              // header="Allopathy"
                              extra={<div className="prescriptionTypeTitle">Allopathy</div>}
                              key='1' showArrow={false}
                              >
                                {p.allopathy.is_completed ?
                                  <div>
                                    <Row className="prescription-table-header" gutter={[8, 8]}>
                                      <Col span={6}>{CONSTANTS.BRAND_DRUG}</Col>
                                      <Col span={3}>{CONSTANTS.DOSAGE}</Col>
                                      <Col span={5}>{CONSTANTS.MED_ROUTE}</Col>
                                      <Col span={3}>{CONSTANTS.FORM}</Col>
                                      <Col span={4}>{CONSTANTS.FREQUENCY}</Col>
                                      <Col span={3}>{CONSTANTS.MED_DURATION}</Col>
                                    </Row>
                                    <ListComponent
                                      className="precription-popup-list"
                                      renderType="server"
                                      data={p.allopathy.medicines}
                                      pagination={null}
                                      render={(listItem) => {
                                        return (
                                          <div className="prescription-card">
                                            {/* <div className="card-datas">

                                              <div className="medicine-datas">
                                                <div className="tablet-name">{listItem?.drug_name}</div>
                                                <div className="tablet-name">{listItem?.brand_name}, <span>&nbsp;{listItem?.dosage}</span></div>
                                                <div className="time-duration-tablet">
                                                  {utils.LineSplit(listItem?.instruction ? listItem.instruction?.replace(/(?<=(?:^|[.?!])\W*)[a-z]/g, i => i.toUpperCase()) : "")}
                                                </div>
                                              </div>
                                              <div className="prescription-duration">{listItem?.duration} ({listItem?.frequency})</div>
                                            </div> */}
                                            <div className="listitem-prescription">
                                              <Row gutter={[8, 8]}>
                                                <Col className="brand-name" span={6}>{utils.Typography(listItem.brand_name) || "-"}</Col>
                                                <Col span={3}>{listItem.dosage || "-"}</Col>
                                                <Col span={5}>{utils.Typography(listItem.route) || "-"}</Col>
                                                <Col span={3}>{utils.Typography(listItem.form) || "-"}</Col>
                                                <Col span={4}>{listItem.frequency || "-"}</Col>
                                                <Col span={3}>{listItem.duration || "-"}</Col>
                                              </Row>

                                              <Row>
                                                {utils.Typography(listItem.drug_name)}
                                              </Row>
                                              {listItem.instruction &&
                                                <Row className="adjuvant" >
                                                  <Col className="adjuvant-label" span={6}>Instructions</Col>
                                                  <Col span={18}>{utils.Typography(listItem.instruction)}</Col>
                                                </Row>
                                              }
                                            </div>
                                          </div>
                                        );
                                      }}
                                    /> </div> : null}
                              </Panel>
                            </Collapse> : null}
                          {p.yoga?.is_completed ?
                            <Collapse 
                            bordered={false}  ghost={true}
                            // expandIconPosition="start"
                            key='1' showArrow={false}
                            >
                              <Panel 
                              // header="Yoga"
                              extra={<div className="prescriptionTypeTitle">Yoga</div>}
                              key='1' showArrow={false}
                              >
                                <Collapse
                                 bordered={false}  ghost={true} 
                                //  expandIconPosition="start"
                                collapsible="icon" defaultActiveKey={[1]}
                                >
                                  <Panel 
                                  // header="Asanas"
                                  extra={<div className="prescriptionTypeTitle">Asanas</div>}
                                  key='1' showArrow={false}
                                  >
                                    <Tabs>
                                      <Tabs.TabPane tab="Pranayama" key="item1">
                                        {(p?.yoga?.asanas?.pranayama || []).map((y,index) => {
                                          let DataSource = [{
                                            asana_name: y.asana_name,
                                            number_of_cycles: y.number_of_cycles,
                                            precautions: utils.LineSplit(y.precautions),
                                            recommendations: utils.LineSplit(y.recommendations)
                                          }]
                                          return (
                                            <div key={index}>
                                              {y.is_selected ? <Table pagination={false} dataSource={DataSource} columns={columns}  /> :
                                                null}
                                            </div>
                                          )
                                        })}
                                      </Tabs.TabPane>
                                      <Tabs.TabPane tab="Prone" key="item2">
                                        {(p.yoga?.asanas?.prone || []).map((y,index) => {
                                          let DataSource = [{
                                            asana_name: y.asana_name,
                                            number_of_cycles: y.number_of_cycles,
                                            precautions: utils.LineSplit(y.precautions),
                                            recommendations: utils.LineSplit(y.recommendations)
                                          }]
                                          return (
                                            <div key={index}>
                                              {y.is_selected ? <Table pagination={false} dataSource={DataSource} columns={columns} /> : null}
                                            </div>
                                          )
                                        })}
                                      </Tabs.TabPane>
                                      <Tabs.TabPane tab="Sitting" key="item3">
                                        {(p.yoga?.asanas?.sitting || []).map((y,index) => {
                                          let DataSource = [{
                                            asana_name: y.asana_name,
                                            number_of_cycles: y.number_of_cycles,
                                            precautions: utils.LineSplit(y.precautions),
                                            recommendations: utils.LineSplit(y.recommendations)
                                          }]
                                          return (
                                            <div key={index}>
                                              {y.is_selected ? <Table pagination={false} dataSource={DataSource} columns={columns} /> : null}
                                            </div>
                                          )
                                        })}
                                      </Tabs.TabPane>
                                      <Tabs.TabPane tab="Standing" key="item4">
                                        {(p.yoga?.asanas?.standing || []).map((y,index) => {
                                          let DataSource = [{
                                            asana_name: y.asana_name,
                                            number_of_cycles: y.number_of_cycles,
                                            precautions: utils.LineSplit(y.precautions),
                                            recommendations: utils.LineSplit(y.recommendations)
                                          }]
                                          return (
                                            <div key={index}>
                                              {y.is_selected ? <Table pagination={false} dataSource={DataSource} columns={columns} /> : null}
                                            </div>
                                          )
                                        })}
                                      </Tabs.TabPane>
                                      <Tabs.TabPane tab="Supine" key="item5">
                                        {(p.yoga?.asanas?.supine || []).map((y,index) => {
                                          let DataSource = [{
                                            asana_name: y.asana_name,
                                            number_of_cycles: y.number_of_cycles,
                                            precautions: utils.LineSplit(y.precautions),
                                            recommendations: utils.LineSplit(y.recommendations)
                                          }]
                                          return (
                                            <div key={index}>
                                              {y.is_selected ? <Table pagination={false} dataSource={DataSource} columns={columns} /> : null}
                                            </div>
                                          )
                                        })}
                                      </Tabs.TabPane>
                                    </Tabs>
                                  </Panel>
                                </Collapse>
                                <Collapse 
                                bordered={false}  ghost={true}
                                // expandIconPosition="start"
                                collapsible="icon" defaultActiveKey={[1]}
                                >
                                  <Panel 
                                  // header="Limitations"
                                  extra={<div className="prescriptionTypeTitle">Limitations</div>}
                                  showArrow={false} key='1'
                                  >
                                    {(p.yoga?.limitation || []).map((l, index) => {
                                      return (
                                        <div key={index}>
                                          {l.is_selected ?
                                            <div className="limit-box">
                                              <div className="limit-content">
                                                <div className="limit-title">{l.limitation_name}</div>
                                                <div>:</div>
                                                <div className="limit-elements"> {l.is_selected ? "Yes" : null}  {l.duration != '' && l.duration != null ? '|' : null}  {l.duration} {l.duration_period}  </div>
                                              </div>
                                            </div>
                                            : null}
                                        </div>
                                      )
                                    })}
                                  </Panel>
                                </Collapse>
                              </Panel>
                            </Collapse> : null}
                          {p.diet?.is_completed ?
                            <Collapse 
                            bordered={false}  ghost={true}
                            // expandIconPosition="start"
                            collapsible="icon" defaultActiveKey={[1]}
                            >
                              <Panel 
                              // header="Diet plans"
                              extra={<div className="prescriptionTypeTitle">Diet plans</div>}
                              showArrow={false} key='1'
                              >
                                <div className="diet-box">
                                  <div className="diet-content">
                                    <div className="diet-title">Wellness Goal and Ayurvedic Approach to Diet</div>
                                    <div>:</div>
                                    <div className="diet-element">{utils.LineSplit(p.diet.wellness_goal)}</div>
                                  </div>
                                </div>
                                {(p.diet?.diet_plan || []).map((d,index) => {
                                  return (
                                    <div key={index}>
                                      {d?.is_diet ? <Card
                                        size="small"
                                        title={<div 
                                          // style={{ fontWeight: "bold" }}
                                          >{utils.ConvertToPascalCase(d?.diet_type || "")}</div>}
                                        style={{ margin: "10px" }}
                                      >
                                        <div className="diet-box">
                                          <div className="diet-content">
                                            <div className="diet-title">Favoured</div>
                                            <div>:</div>
                                            <div className="diet-element">{d.favored ? d.favored.join(" | ") : ""}</div>
                                          </div>
                                          <div className="diet-content">
                                            <div className="diet-title">Avoided</div>
                                            <div>:</div>
                                            <div className="diet-element">{d.avoided ? d.avoided.join(" | ") : ""}</div>
                                          </div>
                                          <div className="diet-content">
                                            <div className="diet-title">Advised</div>
                                            <div>:</div>
                                            <div className="diet-element">{d.advice}</div>
                                          </div>
                                        </div>
                                      </Card> : null}
                                    </div>
                                  )
                                })}
                              </Panel>
                            </Collapse> : null}
                             {p.medical_test?.is_completed ?
                            <Collapse 
                            bordered={false}  ghost={true}
                            // expandIconPosition="start"
                            collapsible="icon" defaultActiveKey={[1]}
                            >
                              <Panel 
                              // header="Medical test"
                              extra={<div className="prescriptionTypeTitle">Medical test</div>}
                              showArrow={false} key='1'
                              >
                                {p?.medical_test.is_completed ?
                                  <div>
                                    <Row className="prescription-table-header" gutter={[8, 8]}>
                                    <Col span={12}>{CONSTANTS.TEST_NAME}</Col>
                                    <Col span={12}>{CONSTANTS.CLINICIAN_INSTRUCTION}</Col>
                                    </Row>
                                    <ListComponent
                                      className="precription-popup-list"
                                      renderType="server"
                                      data={p.medical_test?.test_documents}
                                      pagination={null}
                                      render={(listItem) => {
                                        return (
                                          <div className="prescription-card">
                                           
                                            <div className="listitem-prescription">
                                              <Row gutter={[8, 8]}>
                                              <Col className="brand-name" span={12}>{utils.Typography(listItem.test_name )|| "-"}</Col>
                                              <Col span={12}>{listItem.instructions || "-"}</Col>
                                              </Row>

                                             
                                            </div>
                                          </div>
                                        );
                                      }}
                                    /> </div> : null}
                              </Panel>
                            </Collapse> : null}
                      </>
                        : <Empty className="" description={CONSTANTS.NO_PRESCRIPTION_REQUIRED} image={Empty.PRESENTED_IMAGE_SIMPLE} />
                      }
                        </div>
                        </Panel>
                      </Collapse>
                    </div>
                  )
                })}
              </div>
              :
              <Empty className="prescription-content-empty" description={"No Data"} image={Empty.PRESENTED_IMAGE_SIMPLE} />}
          </div>
        </div>
      </div>
    )}
    </>
    );
  }
}
